import { render, staticRenderFns } from "./XsIdCardBind.vue?vue&type=template&id=6892c85f&"
import script from "./XsIdCardBind.vue?vue&type=script&lang=js&"
export * from "./XsIdCardBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports